import { useState, useEffect } from 'react';

const Header = ({ user }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (d) =>
    d.toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  const formatDate = (d) =>
    d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });

  return (
    <header className="header">
      <div className="header__info">
        <div className="header__name">{user.name}</div>
        <div className="header__email">{user.email}</div>
      </div>
      <div className="header__clock">
        <div className="header__clock-time">{formatTime(time)}</div>
        <div className="header__clock-date">{formatDate(time)}</div>
      </div>
    </header>
  );
};

export default Header;
